import React, { FC } from 'react';
import { Button } from 'react-bootstrap';
import { DocumentViewerFieldModel } from '../../../../models/form/fields/documentViewer';

export interface Props {
  value: string | undefined;
  documentType: DocumentViewerFieldModel['documentType'];
  documentName: string;
}

const DocumentViewerField: FC<Props> = ({ value, documentName, documentType }: Props) => {
  let icon = 'mdi-pdf-box';
  let iconColor = '#c50606';
  if (documentType === 'doc' || documentType === 'docx') {
    icon = 'mdi-file-word-box';
    iconColor = '#215dbe';
  } else if (documentType === 'xls' || documentType === 'xlsx') {
    icon = 'mdi-file-excel-box';
    iconColor = '#20783f';
  }
  return (
    <div>
      <div className="d-flex align-items-center">
        <span
          className={`mdi ${icon} me-2`}
          style={{ color: iconColor, fontSize: 26 }}
          data-testid="document-icon"
        ></span>
        <Button as="a" href={value} variant="link" rel="noreferrer" target="_blank" download className="px-0">
          {documentName + '.' + documentType} <span className="mdi mdi-open-in-new me-2"></span>
        </Button>
      </div>
    </div>
  );
};

export default DocumentViewerField;
